import { API_URL } from "../utils/constants/api";
import LocalStorage from "utils/helpers/localStorage";
import axios from "axios";
import { sanitizeAndTrimInput } from "utils/helpers/string";

const isPlainObject = (value) => {
  if (!value || typeof value !== "object") return false;
  return Object.getPrototypeOf(value) === Object.prototype;
};

const sanitizeRequestValue = (value) => {
  if (typeof value === "string") return sanitizeAndTrimInput(value);

  if (Array.isArray(value)) {
    return value?.map((item) => sanitizeRequestValue(item));
  }

  if (isPlainObject(value)) {
    return Object.keys(value)?.reduce((acc, key) => {
      acc[key] = sanitizeRequestValue(value?.[key]);
      return acc;
    }, {});
  }

  return value;
};

const makeHeaders = (isFileUpload = false) => {
  let access_token = LocalStorage.getAccessToken();

  if (isFileUpload && access_token !== null) {
    return {
      "Content-Type": "multipart/form-data",
      "ACCESS-TOKEN": access_token,
    };
  } else if (access_token !== null)
    return {
      "Content-Type": "application/json",
      "ACCESS-TOKEN": access_token,
      Accept: "application/json",
    };
  else
    return {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
};

const client = (isFileUpload = false) => {
  const instance = axios.create({
    baseURL: API_URL,
    headers: makeHeaders(isFileUpload),
  });

  instance.interceptors.request.use((config) => {
    const contentType =
      config?.headers?.["Content-Type"] || config?.headers?.["content-type"];
    const isMultipartRequest =
      typeof contentType === "string" &&
      contentType?.toLowerCase()?.includes("multipart/form-data");

    if (!isMultipartRequest && config?.data) {
      config.data = sanitizeRequestValue(config?.data);
    }

    if (config?.params) {
      config.params = sanitizeRequestValue(config?.params);
    }

    return config;
  });

  return instance;
};

export { client };
